import { Button, Modal, Text } from '@ksyos/design-system';
import { translateKey } from '@frontend/translate';

interface DeleteActivitiesModalProps {
    isVisible: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
}

export function DeleteActivitiesModal(props: DeleteActivitiesModalProps) {
    const { isVisible, onClose, onConfirm } = props;

    return (
        <Modal
            closeOnEsc={false}
            isOpen={isVisible}
            onClose={onClose}
            size="medium"
        >
            <Modal.Header>Activiteit verwijderen</Modal.Header>
            <Modal.CloseButton />
            <Modal.Body>
                <Text>Let op: Weet je zeker dat je de activiteit(en) uit de lijst wilt verwijderen?</Text>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    onClick={onClose}
                    variant="outline"
                >
                    {translateKey('common.cancel')}
                </Button>
                <Button
                    onClick={onConfirm}
                    variant="solid"
                >
                    {translateKey('common.accept')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
